import React, { useMemo } from "react";
import { graphql, useStaticQuery } from "gatsby";
import Preview from "../components/preview";
import "../components/css/styles.css";

const Popular = ({ n }) => {
  const data = useStaticQuery(graphql`
    query PopularPosts {
      allStrapiArticle(sort: { fields: published_at, order: DESC }, limit: 200) {
        edges {
          node {
            id
            title
            authors {
              id
              name
            }
            categories {
              id
              title
            }
            image {
              publicURL
            }
            published_at
            fields {
              slug
            }
          }
        }
      }
      allPageViews(sort: { order: DESC, fields: totalCount }, limit: 50) {
        edges {
          node {
            path
            totalCount
          }
        }
      }
    }
  `);

  const allArticles = data.allStrapiArticle.edges;
  const popularArticles = data.allPageViews.edges;

  const normalizePath = (p) =>
    (p || "")
      .split(/[?#]/)[0] // drop query/hash if present
      .replace(/^\/+/, "") // drop leading slashes
      .replace(/\/+$/, ""); // drop trailing slashes

  const recentResults = useMemo(() => {
    const ONE_YEAR_MS = 365 * 24 * 60 * 60 * 1000;
    const cutoffDate = new Date(Date.now() - ONE_YEAR_MS);

    // slug -> article node
    const articleBySlug = new Map(
      allArticles.map(({ node }) => [normalizePath(node.fields.slug), node])
    );

    const results = [];
    const seenIds = new Set();

    for (const pv of popularArticles) {
      const slug = normalizePath(pv.node.path);
      const article = articleBySlug.get(slug);
      if (!article) continue;

      // de-dupe identical articles
      if (seenIds.has(article.id)) continue;

      const publishedDate = new Date(article.published_at);
      if (publishedDate < cutoffDate) continue;

      seenIds.add(article.id);
      results.push(article);

      if (results.length >= n) break;
    }

    return results;
  }, [allArticles, popularArticles, n]);

  return (
    <ul>
      {recentResults.map((document) => (
        <li
          key={document.id}
          className="mt-4 pb-4 border-b border-bottom-gray"
        >
          <Preview article={document} format="small" />
        </li>
      ))}
    </ul>
  );
};

export default Popular;

/*import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import Preview from "../components/preview"

import "../components/css/styles.css"

const Popular = ({ n }) => {
    const data = useStaticQuery(graphql`
    query PopularPosts {
        allStrapiArticle(sort: {fields: published_at, order: DESC}, limit: 100) {
          edges {
            node {
                id
                title
                authors {
                    id
                    name
                }
                categories {
                    id
                    title
                }
                image {
                    publicURL
                }
                published_at
                fields {
                    slug
                }
            }
          }
        }
        allPageViews(sort: {order: DESC, fields: totalCount}, limit: 50) {
          edges {
            node {
              path
              totalCount
            }
          }
        }
      }
    `)

    function chooseTop(allArticles, popularArticles, n) {
        const results = [];
        for (const a of popularArticles) {
            const popularArticle = allArticles.find(b => b.node.fields.slug === a.node.path);
            if (popularArticle == null) {
                continue;
            } else {
                results.push({
                    ...popularArticle.node,
                });
            }
            if (results.length >= n) {
                break;
            }
        };
        return results;
    }

    const recentResults = chooseTop(data.allStrapiArticle.edges, data.allPageViews.edges, n);

    return (
        <ul>
            {recentResults.map(document => (
                <li key={document.id} className="mt-4 pb-4 border-b border-bottom-gray">
                    <Preview article={document} format="small" />
                </li>
            ))}
        </ul>
    )
}

export default Popular*/
/*const Popular = ({ n }) => {
    const data = useStaticQuery(graphql`
    query RecentPosts {
        allStrapiArticle(sort: {fields: published_at, order: DESC}, limit: 100) {
          edges {
            node {
                id
                title
                authors {
                    id
                    name
                }
                categories {
                    id
                    title
                }
                image {
                    publicURL
                }
                published_at
                fields {
                    slug
                }
            }
          }
        }
      }
    `)

    function getRecentArticles(allArticles, n) {
        return allArticles.slice(0, n).map(article => ({
            ...article.node,
        }));
    }

    const recentArticles = getRecentArticles(data.allStrapiArticle.edges, n);

    return (
        <div>
            {recentArticles.map(article => (
                <Preview key={article.id} article={article} />
            ))}
        </div>
    );
}

export default Popular;*/

